import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { Navbar, NavbarGroup } from '@blueprintjs/core';
// import '../client-project/CPNavBar.scss';
import 'src/styles/components/_subNavBar.scss';

const CPNavBar: React.FC = () => {
    type page = 'clientmaintenance' | 'projectmaintenance' | 'clientcontactmaintenance' | 'clientbillingmaintenance' | 'projectbillingmaintenance' | 'subcodemaintenance' | 'projectstaffing';

    const dispatch = useDispatch();
    const [currentSection, setCurrentSection] = useState<page>(undefined);

    useEffect(() => {
        if (window.location.pathname.indexOf('/clientmaintenance') >= 0) {
            setCurrentSection('clientmaintenance');
        } else if (window.location.pathname.indexOf('/projectmaintenance') >= 0) {
            setCurrentSection('projectmaintenance');
        } else if (window.location.pathname.indexOf('/clientcontactmaintenance') >= 0) {
            setCurrentSection('clientcontactmaintenance');
        } else if (window.location.pathname.indexOf('/clientbillingmaintenance') >= 0) {
            setCurrentSection('clientbillingmaintenance');
        } else if (window.location.pathname.indexOf('/projectbillingmaintenance') >= 0) {
            setCurrentSection('projectbillingmaintenance');
        } else if (window.location.pathname.indexOf('/subcodemaintenance') >= 0) {
            setCurrentSection('subcodemaintenance');
        } else if (window.location.pathname.indexOf('/projectstaffing') >= 0) {
            setCurrentSection('projectstaffing');
        }
    });

    const navigate = (path: string) => {
        console.log(currentSection);
        if (window.location.pathname.includes('client-project/') && currentSection) {
            let newPath = path.replace('client-project/', '');
            dispatch(push(newPath));
        } else {
            dispatch(push(path));
        }
    };

    const isActive = (section: string) => {
        if (section === currentSection) {
            return 'active';
        }
        return '';
    };

    return (
        <Navbar className="nav-bar">
            <NavbarGroup>
                <div className={'sub-nav-menu-item ' + isActive('clientmaintenance')} onClick={() => navigate('client-project/clientmaintenance')}>
                    Client
                </div>
                <div className={'sub-nav-menu-item ' + isActive('clientcontactmaintenance')} onClick={() => navigate('client-project/clientcontactmaintenance')}>
                    Client Contact
                </div>
                <div className={'sub-nav-menu-item ' + isActive('clientbillingmaintenance')} onClick={() => navigate('client-project/clientbillingmaintenance')}>
                    Client Billing
                </div>
                <div className={'sub-nav-menu-item ' + isActive('projectmaintenance')} onClick={() => navigate('client-project/projectmaintenance')}>
                    Project
                </div>
                <div className={'sub-nav-menu-item ' + isActive('projectbillingmaintenance')} onClick={() => navigate('client-project/projectbillingmaintenance')}>
                    Project Billing
                </div>
                <div className={'sub-nav-menu-item ' + isActive('subcodemaintenance')} onClick={() => navigate('client-project/subcodemaintenance')}>
                    Subcode
                </div>
                <div className={'sub-nav-menu-item ' + isActive('projectstaffing')} onClick={() => navigate('client-project/projectstaffing')}>
                    Staffing
                </div>
            </NavbarGroup>
        </Navbar>
    );
};

export default CPNavBar;



// WEBPACK FOOTER //
// ./src/components/client-project/CPNavBar.tsx